import { Badge, Col, Container, Row } from 'react-bootstrap';

const Hero = ({ sectionData }) => {
  const badgeText = sectionData?.section_name?.trim() || 'Contact';
  const titleText = sectionData?.title?.trim() || "Let's plan your next trip together";
  const introText =
    sectionData?.intro_text ??
    'Our travel specialists in Ierapetra are here to answer questions, design tailored itineraries, and support your guests throughout their stay in Crete.';

  const bgColor = sectionData?.content?.background_color || sectionData?.background_color || 'light';
  const bgEffect = sectionData?.content?.background_effect || sectionData?.background_effect || null;
  let bgClass = bgColor === 'primary' ? 'section-bg-primary' : bgColor === 'white' ? 'bg-white' : bgColor === 'dark' ? 'bg-dark text-white' : 'bg-light';
  if (bgColor === 'primary' && bgEffect === 'gradient') bgClass = 'section-bg-primary-gradient';
  const hasDotsEffect = bgColor === 'primary' && bgEffect === 'dots';
  const useDbBackground = !!(sectionData?.content?.background_color || sectionData?.background_color);

  return (
    <section className={`contact-hero-section pt-4 pt-md-5 ${bgClass} ${hasDotsEffect ? 'overflow-hidden position-relative' : ''}`} {...(useDbBackground && { 'data-bg-from-db': 'true' })}>
      {hasDotsEffect && (
        <>
          <span className="section-bg-dots section-bg-dots--left d-none d-xl-block" />
          <span className="section-bg-dots section-bg-dots--right d-none d-lg-block" />
        </>
      )}
      <Container>
        <Row className="mb-4 mb-lg-5">
          <Col xl={10}>
            <Badge bg="primary" className="bg-opacity-10 text-primary px-3 py-2 mb-3 contact-hero__badge">
              {badgeText}
            </Badge>
            <h1 className="sec-title mb-3">{titleText}</h1>
            <p className="lead intro-text mb-0">
              <span dangerouslySetInnerHTML={{ __html: introText }} />
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Hero;

